import { keys, split } from 'lodash';

const getUrlQueryStrings = (config, postalCode) => {
  const rpos = config.selections.rpos;
  const accessories = config.selections.accessories;

  const query = {
    styleId: config.styleId,
    rpo: rpos.slice().concat(accessories).join(','),
    ss: config.ss,
    postalCode,
  };

  const queryString = keys(query)
    .filter((key) => {
      return query[key];
    })
    .map((key) => {
      return `${key}=${query[key]}`;
    })
    .join('&');
  return queryString;
};

export const getDeepUrl = (baseURL, config, postalCode) => {
  return `${baseURL}summary?${getUrlQueryStrings(config, postalCode)}`;
};

export const getEncodedDeepUrl = (baseURL, config, postalCode) => {
  return `${baseURL}summary?${encodeURIComponent(
    getUrlQueryStrings(config, postalCode)
  )}`;
};

export const getBaseUrl = () =>
  window.document.baseURI ||
  window.document.getElementsByTagName('base')[0].href;

export const getOrigin = () => {
  const baseUrl = getBaseUrl();
  const segments = split(baseUrl, '/');
  return segments.length > 3
    ? `${segments[0]}//${segments[2]}`
    : window?.location?.origin;
};
